module.exports = __webpack_public_path__ + "img/input-text.ffc500fb.svg";